module.exports = __webpack_public_path__ + "img/delivery1_2.dd4a8c5e.png";